[
  {
    "id": "012b1203-3d15-71b2-819a-315043dc5bd8",
    "scanDate": "2025-12-11T12:00:00Z",
    "floor": 1
  }
]